import { createSelector } from "@reduxjs/toolkit";

import { IUserPassport } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { buildData, dataSelector } from "../helpers";

export const userPassportsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userPassport) as IUserPassport[]
);

const dataUserPassportsSelector = createSelector(dataSelector, data => data.userPassport);

export const userPassportSelectorCreator = (id: string) =>
  createSelector(dataUserPassportsSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_PASSPORT(id)];
    return item ? (buildSingleItem(item) as IUserPassport) : undefined;
  });
